export const account_manager = "accounts";
export const curriculum_manager = "curriculum";
export const finance_manager = "finance";
export const ecommerce_manager = "ecommerce";